// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.toolbar {
  gap: 8px;
}

.stream-name {
  font-weight: 500;
}

.stream-started {
  margin-left: 12px;
  font-size: 12px;
  opacity: 0.6;
}

mat-tab-group {
  height: 100%;
  overflow: hidden;
}

.config-tab {
  margin: var(--content-margin, 1rem) calc(var(--content-margin, 1rem) / 2) 0px;
}
.config-tab .config-group {
  display: flex;
  -moz-column-gap: var(--content-gutter);
       column-gap: var(--content-gutter);
  flex-wrap: wrap;
}
.config-tab .config-group .form-field {
  flex: 1 0 180px;
}

.terminal-tab {
  height: 100%;
  margin-top: -5px;
}

.no-data {
  font-size: 1.125rem;
  font-weight: 600;
  text-align: center;
  padding: 1rem 0;
}

.keys-table-container {
  height: calc(100% - 76px);
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/stream-detail-widget/stream-detail-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,QAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,6EAAA;AACF;AACE;EACE,aAAA;EACA,sCAAA;OAAA,iCAAA;EACA,eAAA;AACJ;AACI;EACE,eAAA;AACN;;AAIA;EACE,YAAA;EACA,gBAAA;AADF;;AAIA;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AADF;;AAIA;EACE,yBAAA;EACA,gBAAA;AADF","sourcesContent":[".content {\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.toolbar {\n  gap: 8px;\n}\n\n.stream-name {\n  font-weight: 500;\n}\n\n.stream-started {\n  margin-left: 12px;\n  font-size: 12px;\n  opacity: 0.6;\n}\n\nmat-tab-group {\n  height: 100%;\n  overflow: hidden;\n}\n\n.config-tab {\n  margin: var(--content-margin, 1rem) calc(var(--content-margin, 1rem) / 2) 0px;\n\n  .config-group {\n    display: flex;\n    column-gap: var(--content-gutter);\n    flex-wrap: wrap;\n\n    .form-field {\n      flex: 1 0 180px;\n    }\n  }\n}\n\n.terminal-tab {\n  height: 100%;\n  margin-top: -5px;\n}\n\n.no-data {\n  font-size: 1.125rem;\n  font-weight: 600;\n  text-align: center;\n  padding: 1rem 0;\n}\n\n.keys-table-container {\n  height: calc(100% - 76px);\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
